/**
 * @generated SignedSource<<920a7565e0509c03b65c17d2a366722e>>
 * @relayHash b2369e0289e975a9f84656a4319030a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a1ad8e6139d4f5d49f4240b4fb65b4bb814e4076d6929541213b5c84b1ea3d5e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteOverviewQuery } from './SupportWebsiteOverviewQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteOverviewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a1ad8e6139d4f5d49f4240b4fb65b4bb814e4076d6929541213b5c84b1ea3d5e",
    "metadata": {},
    "name": "SupportWebsiteOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
